import React from 'react';

import Layout from '~/src/features/_layout';
import CatchupLayout from '~/src/features/catchup';
import * as base from '~/src/helpers/basePageFunc';
import { getCurrentCity, selectCompanyName } from '~/src/store/selectors/city';

class Catchup extends React.Component {

    // @TODO удалил странную логику, оставил хардкод для НЗ, разобраться в рамках WEB-43437
    static async getInitialProps(options) {
        await base.initialProps(options);
        const telearchivePrice = 90;
        const state = options.store.getState();
        const city = getCurrentCity(state);
        const companyName = selectCompanyName(state);

        return {
            price: telearchivePrice,
            city,
            companyName,
        };
    }

    render() {
        const { city, price, companyName, ...props } = this.props;

        return (
            <Layout
                title={`Архив ТВ смотреть онлайн в записи от ${companyName} в ${city.name}`}
                description={`Провайдер ${companyName} предлагает подключить услугу «Управляй просмотром». Более 200 ТВ каналов ` +
                    `доступны в записи 7 дней после эфира. Узнайте подробнее на нашем сайте или по тел.: ${city.phone}`}
                withMenu={true}
                withFooter={false}
                withChat={true}
                {...props}
            >
                <CatchupLayout price={price} />
            </Layout>
        );
    }

}

export default Catchup;
